import { render, staticRenderFns } from "./dailyBudget.vue?vue&type=template&id=481e19af&"
import script from "./dailyBudget.vue?vue&type=script&lang=js&"
export * from "./dailyBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports